<div class="ctlDateSelector" (click)="open()">
   {{displayText}} <fa-icon style="padding-left:10px" icon="calendar"></fa-icon>
</div>